export default __webpack_public_path__ + "static/media/about.9b97ae75.png";